export const actions = {
  toggleProfile(context) {
    context.commit('TOGGLE_PROFILE_CARD');
  },
  turnOffProfile(context) {
    context.commit('TURN_OFF_PROFILE_CARD');
  }
};
